module.exports = __webpack_public_path__ + "img/nosort.b672bb0f.svg";